











import { Product } from '@/services/catalog.service';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProductItem extends Vue {
    @Prop() private model!: Product;

    data() {
        return {
        }
    }

    getAssetPath(image:string):string {
        let images = require.context('../../assets/', true, /\.(gif|jpg|png|svg)$/);
        return images(image);

    }
}
